module.exports = __webpack_public_path__ + "static/media/breedon.528afde0.png";